var map = {
	"./google-play-badge-da-DK.svg": 75939,
	"./google-play-badge-de-DE.svg": 41057,
	"./google-play-badge-en-GB.svg": 87019,
	"./google-play-badge-en-US.svg": 94372,
	"./google-play-badge-es-ES.svg": 83123,
	"./google-play-badge-es-MX.svg": 95520,
	"./google-play-badge-fr-FR.svg": 75863,
	"./google-play-badge-it-IT.svg": 79737,
	"./google-play-badge-nb-NO.svg": 43370,
	"./google-play-badge-nl-NL.svg": 48175,
	"./google-play-badge-pl-PL.svg": 70259,
	"./google-play-badge-pt-BR.svg": 2827,
	"./google-play-badge-pt-PT.svg": 52819,
	"./google-play-badge-sv-SE.svg": 31186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;